import generateSafeframeAdImpl from './safeframe/generateSafeframeAd';
import { track } from '../tracking';
import { withAdResponseReceivedEvent } from '../tracking/events';
export default (function () {
  var generateSafeframeAd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateSafeframeAdImpl;
  var shouldTrackEvent = arguments.length > 1 ? arguments[1] : undefined;
  return function (adSpot, response) {
    var contentType = response.contentType,
        _response$content = response.content,
        fcid = _response$content.fcid,
        adId = _response$content.adId,
        adType = _response$content.adtype,
        size = _response$content.size;
    adSpot.nativeType = 'html';
    adSpot.prebidAdId = adId;
    adSpot.prebidSize = size;
    var eventProperties = {
      adResponseContentType: contentType,
      fcid: fcid,
      jsonResponseAdType: adType
    };
    track(withAdResponseReceivedEvent(eventProperties), adSpot, shouldTrackEvent);
    return generateSafeframeAd(adSpot);
  };
});
//# sourceMappingURL=createPrebidAdHandler.js.map